export const BACK_BUTTON_LABELS = {
  1: 'Volver al carro',
  2: 'Volver al contacto',
  3: 'Volver a la entrega',
};

export const SUBMIT_BUTTON_LABEL = {
  1: 'Continuar con la entrega',
  2: 'Continuar con el pago',
  3: 'Realizar pedido',
};

export const getBackButtonLabel = (
  step: keyof typeof BACK_BUTTON_LABELS,
  isLoggedIn: boolean
): string => {
  const index = isLoggedIn && step === 2 ? 1 : step;
  return BACK_BUTTON_LABELS[index];
};
